export default __webpack_public_path__ + "static/media/Ellipse30Track5.692a8604.svg";